import React, { useEffect, useState } from "react"
import BlogCard from "../../../components/BlogCard"
import DefaultButton from "../../../components/DefaultButton"
import { BaseUrl } from "../../../helper/BaseUrl";


 

export default function BlogDetailCards({initialData}){

   const [allData, setAllData] = useState(initialData || []);
  // API Calling
  const fetcher = async () => {
    try {
      const response = await fetch(`${BaseUrl}api/blogs`, {
        method: 'GET',
      });
      const result = await response.json();
      if (result.blogs === false) {
        throw new Error(`API error: ${result.message}`);
      }
      setAllData(result.blogs);
    } catch (error) {
      console.error('Fetch error:', error.message);
    }
  };
  useEffect(() => {
    fetcher();
  }, [])

  if (!allData) {
    return <div style={{ height: "100vh", width: "100%" }}></div>;
  }
   return(
    <>
    <section className="detailcards-area">
      <div className="container">
        <div className="row">
          <div className="col-lg-12">
            <h2 className="heading center-heading">You might also be <br /> interested in</h2>
          </div>
          <BlogCard allData={allData?.slice(-3)}  btnText = "Read More" isBlogList  />
          <div className="col-lg-12">
            <div className="blogdeatail-viewall">
            <DefaultButton  text="view all" to={"/blog"} color/>
            </div>
          </div>
        </div>
      </div>
    </section>
    </>
   )
}